import Button from 'components/form/Button'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import Tooltip from 'components/tooltip/Tooltip'
import { useDialog } from 'features/dialog/Dialog'
import CopyKeywordsDialog from 'features/dashboard/operation/keywordCopy/CopyKeywordsDialog'

const KeywordCopyButton = () => {
  const { selectedIds, content } = useDashboardTableSelector()
  const [CopyKeywords, showCopyKeywords, hideCopyKeywords] = useDialog()
  const hasSameAdGroup =
    selectedIds.length === 1 ||
    (selectedIds.length > 1 &&
      content
        .filter(({ id }) => selectedIds.includes(id))
        .map(
          ({
            parentDomainInfo: {
              adGroup: { id },
            },
          }) => id
        )
        .every((value, index, array) => value === array[0]))
  return (
    <>
      {hasSameAdGroup ? (
        <Button line onClick={showCopyKeywords}>
          복사
        </Button>
      ) : (
        <Tooltip
          tag="button"
          container="dashboardWrap"
          content="광고그룹이 동일한 키워드에 한해 복사 가능합니다."
          position="bottom alignLeft"
          offsetY={5}
          wrapperClassName="btn_gm in_active"
          style={{ pointerEvents: 'auto' }}>
          <span className="inner_g">복사</span>
        </Tooltip>
      )}
      <CopyKeywords type="basic_layer" className="copy_layer">
        <CopyKeywordsDialog handleClose={hideCopyKeywords} />
      </CopyKeywords>
    </>
  )
}
export default KeywordCopyButton
